module.exports = __webpack_public_path__ + "static/img/person2.035fc39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/person2.png
// module id = v3jR
// module chunks = 1